/** Public marketing site (sibling repo x9-marketing → x9.app). */
export const MARKETING_ORIGIN = 'https://x9.app';

/**
 * Marketing currently ships `ACTIVE_LOCALES = ["en"]` only; use `en` until
 * pt-BR is flipped back on in x9-marketing.
 */
export function marketingHomeUrl(locale: 'en' | 'pt-br' = 'en'): string {
  return `${MARKETING_ORIGIN}/${locale}`;
}

export function marketingPricingUrl(locale: 'en' | 'pt-br' = 'en'): string {
  return `${MARKETING_ORIGIN}/${locale}/pricing`;
}

export function openMarketingHome(locale: 'en' | 'pt-br' = 'en'): void {
  window.location.assign(marketingHomeUrl(locale));
}

export function openMarketingPricing(locale: 'en' | 'pt-br' = 'en'): void {
  window.location.assign(marketingPricingUrl(locale));
}
